import { StorageKeys } from 'common'

export const getCondensedViewState = (): boolean => {
  const isCondensedView =
    localStorage.getItem(StorageKeys.CONDENSEDVIEW_KEY) === 'true' || false
  try {
    return isCondensedView
  } catch (_e) {
    return false
  }
}
